import React from 'react';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import usePage from '@dashboard/hooks/usePage';
import { Form } from '@dashboard/components/Formik';
import { pageLayoutTypes } from '@dashboard/enums/page-layout-types';
import { pageUsageTypes } from '@dashboard/enums/page-usage-types';
import { PAGE_TYPES } from '@dashboard/enums/page-types';

const ColorsForm = () => {
  const { page, updatePage } = usePage();
  const { seller } = useAuth();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        backgroundColor: page.backgroundColor || '#ffffff',
        primaryTextColor: page.primaryTextColor || '#000000',
        secondaryTextColor: page.secondaryTextColor || '#685357',
        buttonBackgroundColor: page.buttonBackgroundColor || seller.brandColor || '',
        buttonTextColor: page.buttonTextColor || '',
        paymentOptionBackgroundColor: page.paymentOptionBackgroundColor || '',
        paymentOptionSelectedBackgroundColor: page.paymentOptionSelectedBackgroundColor || '',
        paymentOptionSelectedBorderColor:
          page.paymentOptionSelectedBorderColor || seller.brandColor || '',
        variantBackgroundColor: page.variantBackgroundColor || '',
        variantSelectedBackgroundColor: page.variantSelectedBackgroundColor || '',
        variantSelectedBorderColor: page.variantSelectedBorderColor || seller.brandColor || '',
        ticketTypeBackgroundColor: page.ticketTypeBackgroundColor || '',
        ticketTypeSelectedBackgroundColor: page.ticketTypeSelectedBackgroundColor || '',
        ticketTypeSelectedBorderColor: page.ticketTypeSelectedBorderColor || seller.brandColor,
      }}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync(values);

        return {
          data,
          error,
        };
      }}
      fields={[
        {
          name: 'backgroundColor',
          label: 'Background color',
          type: 'color-select',
          hidden: page.usageType === pageUsageTypes.SITE,
        },
        {
          name: 'primaryTextColor',
          label: 'Primary text color',
          type: 'color-select',
          hidden:
            page.hostedLayoutType === pageLayoutTypes.CENTER ||
            page.hostedLayoutType === pageLayoutTypes.SPLIT,
        },
        {
          name: 'secondaryTextColor',
          label: 'Secondary text color',
          type: 'color-select',
          hidden:
            page.type !== PAGE_TYPES.CHECKOUT ||
            page.hostedLayoutType === pageLayoutTypes.CENTER ||
            page.hostedLayoutType === pageLayoutTypes.SPLIT,
        },
        {
          type: 'divider',
          visible: page.product?.variants?.length > 0,
        },
        {
          name: 'variantBackgroundColor',
          label: 'Variant background color',
          type: 'color-select',
          visible: page.product?.variants?.length > 0,
        },
        {
          name: 'variantSelectedBackgroundColor',
          label: 'Variant selected background color',
          type: 'color-select',
          visible: page.product?.variants?.length > 0,
        },
        {
          name: 'variantSelectedBorderColor',
          label: 'Variant selected border color',
          type: 'color-select',
          visible: page.product?.variants?.length > 0,
        },
        {
          type: 'divider',
          visible: page.type === 'event',
        },
        {
          name: 'ticketTypeBackgroundColor',
          label: 'Ticket type background color',
          type: 'color-select',
          visible: page.type === 'event',
        },
        {
          name: 'ticketTypeSelectedBackgroundColor',
          label: 'Ticket type selected background color',
          type: 'color-select',
          visible: page.type === 'event',
        },
        {
          name: 'ticketTypeSelectedBorderColor',
          label: 'Ticket type selected border color',
          type: 'color-select',
          visible: page.type === 'event',
        },
        {
          type: 'divider',
          visible:
            page.paymentOptions
              ?.filter(option => option.enabled)
              ?.filter(option => option.type !== 'full').length > 0,
        },
        {
          name: 'paymentOptionBackgroundColor',
          label: 'Manual payment option background color',
          type: 'color-select',
          visible:
            page.paymentOptions
              ?.filter(option => option.enabled)
              ?.filter(option => option.type !== 'full').length > 0,
        },
        {
          name: 'paymentOptionSelectedBorderColor',
          label: 'Manual payment option selected border color',
          type: 'color-select',
          visible:
            page.paymentOptions
              ?.filter(option => option.enabled)
              ?.filter(option => option.type !== 'full').length > 0,
        },
        {
          name: 'paymentOptionSelectedBackgroundColor',
          label: 'Manual payment option selected background color',
          type: 'color-select',
          visible:
            page.paymentOptions
              ?.filter(option => option.enabled)
              ?.filter(option => option.type !== 'full').length > 0,
        },
        {
          type: 'divider',
        },
        {
          name: 'buttonBackgroundColor',
          label: 'Button background color',
          type: 'color-select',
        },
        {
          name: 'buttonTextColor',
          label: 'Button text color',
          type: 'color-select',
        },
      ]}
    />
  );
};

export default ColorsForm;
